import React from 'react';
import { Typography } from '@mui/material';
import { footerStyles } from '../../styles/landing';

const Footer = () => {
    const classes = footerStyles()
  return (
    <div className={classes.footer}>
         <Typography variant="subtitle1"  
          style={{padding:20, 
          display:"flex", 
          justifyContent:"center",
          color:"#fff"}}
          >
         ©2023 by ArborHawk.
            </Typography>
    
    </div>
  )
}

export default Footer